import { GA4Event } from "./GA4Event";

export {
	buildViewPromotionEvent
};

function buildViewPromotionEvent(message) {
	const { component, promotion_creative, position, promotion_id, promotion_name, items } = message.params;
	const event = new GA4Event("view_promotion", {
		creative_name: promotion_creative,
		creative_slot: position.toString(),
		promotion_id: promotion_id || component,
		promotion_name: promotion_name
	});
	const eventData = event.build();
	const eventItems = [];
	for (const item of items) {
		const data = event.buildItem(item, true);
		eventItems.push(data);
	}
	eventData.params.items = eventItems;
	return eventData;
}